import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import {
  getMaterialClassification,
  getScrapFromOrganization,
  selectScrapItems,
} from "../../../../redux/action/classificationScrap";
import { notifyError } from "../../../../helpers/helpers";

function AddScrapMaterial({ existingScrap }) {
  const dispatch = useDispatch();
  const { scrapLoading, scarpItem } = useSelector(
    (state) => state.materialClassifications
  );
  const [selectedScarpItem, setselectedScarpItem] = useState([]);

  const handleSelectScarp = (item) => {
    const updatedScrap = selectedScarpItem?.map((scrap) => {
      if (scrap._id === item._id) {
        return { ...scrap, selected: !scrap.selected };
      }
      return scrap;
    });
    setselectedScarpItem(updatedScrap);
  };

  const checkScrapSelected = () => {
    return !selectedScarpItem?.some((scrap) => scrap?.selected);
  };

  const handleAddScrap =  () => {
    const scrapIdList = selectedScarpItem
      .filter((obj) => obj?.selected)
      ?.map((obj) => obj?._id);

    const existingSelectedScrap = existingScrap?.filter((item) => scrapIdList?.includes(item?._id))
    const materialClassifications = existingSelectedScrap.map(item => item.materialClassification)

    if (materialClassifications.length > 0) {
      return notifyError(`You have already selected ${materialClassifications.join(", ")} in existing scrap.`)
    }

    dispatch(selectScrapItems(scrapIdList)).then(() => {
      setselectedScarpItem(scarpItem);
      dispatch(getScrapFromOrganization());
    });
  };

  useEffect(() => {
    dispatch(getMaterialClassification());
  }, [dispatch]);

  useEffect(() => {
    setselectedScarpItem(scarpItem);
  }, [scarpItem]);

  return (
    <div>
      <div className="valign-wrapper flex-wrap gap-1">
        {selectedScarpItem?.map((item) => (
          <span
            className={`valign-wrapper justify-center gap-1 pointer`}
            key={item?._id}
            style={{
              border: item?.selected
                ? "1px solid #6f2da8"
                : "1px solid #e7e7e7",
              padding: "8px 20px",
              borderRadius: "22px",
              backgroundColor: item?.selected ? "#6f2da8" : "white",
            }}
            onClick={() => handleSelectScarp(item)}
          >
            <p
              className={`font-16px ${item?.selected ? "white-text" : "cercle-purple-text"
                }`}
            >
              {item?.materialClassification}
            </p>
          </span>
        ))}
      </div>
      <p className="flex justify-end mt-1 mr-2">
        <button
          className="button-style pointer"
          style={{
            padding: "8px 20px",
            backgroundColor: checkScrapSelected() ? "#e0e0e0" : "#6f2da8",
            color: !checkScrapSelected() && "#e0e0e0",
          }}
          disabled={checkScrapSelected()}
          onClick={handleAddScrap}
        >
          {scrapLoading ? <ClipLoader color="red" size={20} /> : "Submit"}
        </button>
      </p>
    </div>
  );
}

export default AddScrapMaterial;
